import Company from 'components/views/FounderSettings/_components/Company';
import withDismount from 'hocs/withDismount';
import PageTitle from 'components/global/PageTitle/PageTitle';

const FounderSettings = () => (
  <>
    <PageTitle>Settings</PageTitle>
    <Company />
  </>
);

export default withDismount(FounderSettings);
